/** Used to hide native scrollbars that measure a height of 0 (e.g. due to MacOS auto-hide) */
export const DEFAULT_SCROLLBAR_OFFSET = 30;
